<template>
  <header 
    :class="{'header-small': isHeaderSmall, 'header-hidden': isHeaderHidden}" 
    class="bg-blue-800 p-4 shadow-lg transition-all duration-1000 ease-in-out fixed top-0 left-0 w-full z-50"
  >
    <div class="container mx-auto flex flex-col md:flex-row justify-between items-center px-4">
      <img 
        v-show="!isMenuOpen"
        src="../assets/logo.png" 
        alt="Logo da Clínica Odonto" 
        class="logo transition-transform transform hover:scale-110 animate-logo"
      />      
      <h1 class="text-white text-4xl font-semibold opacity-0 animate-fadeIn md:ml-4">Dental Clinic</h1>
      <h4 class="text-white text-2xl font-semibold opacity-0 animate-fadeIn md:ml-4">Dr. Corneaud</h4>

      <!-- Navegação para desktop -->
      <nav class="hidden md:flex space-x-6 text-white font-medium mt-4 md:mt-0">
        <a href="/" class="hover:text-blue-600 transition-colors duration-300">Home</a>
        <a href="/services" class="hover:text-blue-600 transition-colors duration-300">Services</a>
        <a href="/contact" class="hover:text-blue-600 transition-colors duration-300">Contact</a>
      </nav>

      <!-- Menu hamburguer para mobile -->
      <button 
        @click="toggleMenu" 
        class="md:hidden flex items-center justify-center text-white hover:bg-blue-600 p-2 rounded-md"
        aria-label="Menu de navegação"
      >
        <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>
    </div>

    <!-- Menu mobile -->
    <div v-if="isMenuOpen" class="md:hidden flex flex-col items-center space-y-4 p-4 bg-blue-800 text-white mt-4">
      <a href="/" class="hover:text-white-600">Home</a>
      <a href="/about" class="hover:text-white-600">About</a>
      <a href="/services" class="hover:text-white-600">Services</a>
      <a href="/contact" class="hover:text-white-600">Contact</a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
      isMenuOpen: false,
      isHeaderSmall: false,
      isHeaderHidden: false,
      lastScrollY: 0
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    handleScroll() {
      this.isHeaderSmall = window.scrollY > 5; 
      this.isHeaderHidden = window.scrollY > this.lastScrollY && window.scrollY > 10; 
      this.lastScrollY = window.scrollY;
    }
  },
  mounted() {
    setTimeout(() => {
      this.isHeaderSmall = true;
    }, 1500);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>
@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes logoGrowShrink {
  0% { transform: scale(8); }
  100% { transform: scale(1); }
}

.animate-logo {
  animation: logoGrowShrink 1.5s ease-out forwards;
}

.animate-fadeIn {
  animation: fadeIn 1.5s ease-in-out forwards;
}

.logo {
  width: auto;
  max-width: 200px;
  transition: transform 0.5s ease;
}

/* Mantém o cabeçalho fixo */
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 50;
  transition: all 0.3s ease-in-out;
}

/* Reduz a altura do cabeçalho */
.header-small {
  padding: 0.5rem 0;
}

/* Esconde o cabeçalho ao rolar para baixo */
.header-hidden {
  opacity: 0;
  visibility: hidden;
}
</style>
